import type React from "react"

import { styled } from "styled-components"

const _dotPulseAnimation = styled.div`
  position: relative;

  animation: dotPulseAnimation 1.5s infinite linear;
  animation-delay: 0s;
  animation-delay: 0.25s;

  left: -9999px;
  width: var(--pulse-size);
  height: var(--pulse-size);
  border-radius: calc(var(--pulse-size) / 2);
  box-shadow: 9999px 0 0 calc(-1 * var(--pulse-size) / 2);

  &::before,
  &::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
    width: var(--pulse-size);
    height: var(--pulse-size);
    border-radius: calc(var(--pulse-size) / 2);
  }

  &::before {
    box-shadow: calc(9999px - var(--pulse-size) * 1.5) 0 0
      calc(-1 * var(--pulse-size) / 2);
    animation: dotPulseBeforeAnimation 1.5s infinite linear;
    animation-delay: 0s;
    animation-delay: 0s;
  }

  &::after {
    box-shadow: calc(9999px + var(--pulse-size) * 1.5) 0 0
      calc(-1 * var(--pulse-size) / 2);
    animation: dotPulseAfterAnimation 1.5s infinite linear;
    animation-delay: 0s;
    animation-delay: 0.5s;
  }

  @keyframes dotPulseBeforeAnimation {
    0% {
      box-shadow: calc(9999px - var(--pulse-size) * 1.5) 0 0
        calc(-1 * var(--pulse-size) / 2);
    }
    30% {
      box-shadow: calc(9999px - var(--pulse-size) * 1.5) 0 0
        calc(var(--pulse-size) / 5);
    }
    60%,
    100% {
      box-shadow: calc(9999px - var(--pulse-size) * 1.5) 0 0
        calc(-1 * var(--pulse-size) / 2);
    }
  }

  @keyframes dotPulseAnimation {
    0% {
      box-shadow: 9999px 0 0 calc(-1 * var(--pulse-size) / 2);
    }
    30% {
      box-shadow: 9999px 0 0 calc(var(--pulse-size) / 5);
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 calc(-1 * var(--pulse-size) / 2);
    }
  }

  @keyframes dotPulseAfterAnimation {
    0% {
      box-shadow: calc(9999px + var(--pulse-size) * 1.5) 0 0
        calc(-1 * var(--pulse-size) / 2);
    }
    30% {
      box-shadow: calc(9999px + var(--pulse-size) * 1.5) 0 0
        calc(var(--pulse-size) / 5);
    }
    60%,
    100% {
      box-shadow: calc(9999px + var(--pulse-size) * 1.5) 0 0
        calc(-1 * var(--pulse-size) / 2);
    }
  }
`

const DotPulseInner = styled.div<{ $size: number; $color: string }>`
  --pulse-size: ${({ $size }) => $size}px;

  background-color: ${({ $color }) => $color};
  color: ${({ $color }) => $color};

  &::before,
  &::after {
    --pulse-size: ${({ $size }) => $size}px;
    background-color: ${({ $color }) => $color};
    color: ${({ $color }) => $color};
  }

  position: relative;

  animation: dotPulseAnimation 1.5s infinite linear;
  animation-delay: 0s;
  animation-delay: 0.25s;

  left: -9999px;
  width: var(--pulse-size);
  height: var(--pulse-size);
  border-radius: calc(var(--pulse-size) / 2);
  box-shadow: 9999px 0 0 calc(-1 * var(--pulse-size) / 2);

  &::before,
  &::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
    width: var(--pulse-size);
    height: var(--pulse-size);
    border-radius: calc(var(--pulse-size) / 2);
  }

  &::before {
    box-shadow: calc(9999px - var(--pulse-size) * 1.5) 0 0
      calc(-1 * var(--pulse-size) / 2);
    animation: dotPulseBeforeAnimation 1.5s infinite linear;
    animation-delay: 0s;
    animation-delay: 0s;
  }

  &::after {
    box-shadow: calc(9999px + var(--pulse-size) * 1.5) 0 0
      calc(-1 * var(--pulse-size) / 2);
    animation: dotPulseAfterAnimation 1.5s infinite linear;
    animation-delay: 0s;
    animation-delay: 0.5s;
  }

  @keyframes dotPulseBeforeAnimation {
    0% {
      box-shadow: calc(9999px - var(--pulse-size) * 1.5) 0 0
        calc(-1 * var(--pulse-size) / 2);
    }
    30% {
      box-shadow: calc(9999px - var(--pulse-size) * 1.5) 0 0
        calc(var(--pulse-size) / 5);
    }
    60%,
    100% {
      box-shadow: calc(9999px - var(--pulse-size) * 1.5) 0 0
        calc(-1 * var(--pulse-size) / 2);
    }
  }

  @keyframes dotPulseAnimation {
    0% {
      box-shadow: 9999px 0 0 calc(-1 * var(--pulse-size) / 2);
    }
    30% {
      box-shadow: 9999px 0 0 calc(var(--pulse-size) / 5);
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 calc(-1 * var(--pulse-size) / 2);
    }
  }

  @keyframes dotPulseAfterAnimation {
    0% {
      box-shadow: calc(9999px + var(--pulse-size) * 1.5) 0 0
        calc(-1 * var(--pulse-size) / 2);
    }
    30% {
      box-shadow: calc(9999px + var(--pulse-size) * 1.5) 0 0
        calc(var(--pulse-size) / 5);
    }
    60%,
    100% {
      box-shadow: calc(9999px + var(--pulse-size) * 1.5) 0 0
        calc(-1 * var(--pulse-size) / 2);
    }
  }
`

type DotPulseProps = {
  size?: number
  style?: React.CSSProperties
}

export const DotPulse = ({ size = 10, style }: DotPulseProps) => {
  return (
    <div
      style={{
        ...(style ?? {}),
        position: "relative",
        width: size * 4,
      }}
    >
      <DotPulseInner style={{ marginLeft: size * 1.5 }} $size={size} $color="#cacaca" />
    </div>
  )
}
